import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  Signal,
  viewChild,
} from '@angular/core';
import { ChangePhotoDirective } from '../user-profile-general/directives/change-photo.directive';
import { TranslateModule } from '@ngx-translate/core';
import { UserStateService } from '@app/services/user-state/user-state.service';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [TranslateModule, ChangePhotoDirective],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {
  private readonly fileInput: Signal<ElementRef<HTMLInputElement>> =
    viewChild.required('fileInput');
  private readonly userStateService = inject(UserStateService);

  public userAvatar = this.userStateService.photoUrl;
  public firstName = input('');
  public lastName = input('');

  public getInitials(): string {
    const data = this.userStateService.userData()?.data;

    if (!data) return '';

    return (data.firstName[0] + data.lastName[0]).toUpperCase();
  }

  public onImageError(): void {
    this.userStateService.setPhotoUrl('');
  }

  public deletePhoto(): void {
    this.userStateService.deletePhoto().subscribe();
    if (this.fileInput()) {
      this.fileInput().nativeElement.value = '';
    }
  }

  public triggerFileInput(): void {
    this.fileInput().nativeElement.click();
  }
}
